// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import {
	getBreadcrumbsSeoSchema,
	getImageSeoSchema,
	getOrganizationSeoSchema,
} from '../../../../utils/seo-schema';
import { getBreadcrumLocale, pageTypes } from '../../../../utils/url-helpers';
import { Head } from '../../../templates/head';
import { NewGluCardContainer } from '../../organisms/new-glu-course-container';
import PageSection from '../../organisms/page-section';
import SessionCardContainer from '../../organisms/session-card-container';
import ScrollToTop from '../ScrollToTop/scrollToTop';

const NewWebinarLibrary = ({ data, location }) => {
	const { liveWebinarSessions, locale, title } = data.datoCmsGluWebinarsPage;
	const metaContent = {
		noIndex: data.datoCmsGluWebinarsPage.noIndex,
		noFollow: data.datoCmsGluWebinarsPage.noFollow,
		metaInformation: data.datoCmsGluWebinarsPage.seoMeta,
		fallbackTitle: data.datoCmsGluWebinarsPage.eLearningTitle,
		fallbackDescription: '',
		canonicalUrl:
			data.datoCmsGluWebinarsPage?.canonicalUrl || location?.href,
	};
	const courseData = data.allDatoCmsGluCourse;
	const seoSchemas = {
		organization: getOrganizationSeoSchema({
			data,
			url: `${location?.origin}/${getBreadcrumLocale(location)}`,
		}),
		breadcrumbs: getBreadcrumbsSeoSchema({
			pageType: pageTypes.gluWebinarsPage,
			location,
		}),
		image: getImageSeoSchema(data?.headingImage?.url),
	};

	const webcastRefHR = useRef(null);
	const webcastRefHS = useRef(null);
	const upcomingWebinarsRef = useRef(null);
	const associatedCategoryHR =
		courseData?.nodes?.[0]?.associatedCategory || 'HR & Employment Law';
	const associatedCategoryHS =
		courseData?.nodes?.[1]?.associatedCategory || 'Health & Safety';

	const scroll = (anchor) => {
		let top;
		switch (anchor) {
			case 'upcomingWebinars':
				top = upcomingWebinarsRef;
				break;
			case 'webcastHR':
				top = webcastRefHR;
				break;
			case 'webcastHS':
				top = webcastRefHS;
				break;
			default:
				top = null;
				break;
		}
		setTimeout(() => {
			window.scrollTo({
				top: top?.current?.offsetTop - 250,
				left: 0,
				behavior: 'smooth',
			});
		}, 100);
	};

	useEffect(() => {
		const isBrowser = typeof window !== 'undefined';
		if (isBrowser) {
			if (window.location.href.includes('#upcomingWebinars')) {
				scroll('upcomingWebinars');
			}
			if (window.location.href.includes('#webcastHR')) {
				scroll('webcastHR');
			}
			if (window.location.href.includes('#webcastHS')) {
				scroll('webcastHS');
			}
		}
	});

	return (
		<GoogleReCaptchaProvider
			reCaptchaKey={process.env.GATSBY_RECAPTCHA_KEY}
		>
			<Head metaContent={metaContent} seoSchemas={seoSchemas} />
			<div className="">
				<PageSection theme="White">
					<h1
						id="upcomingWebinars"
						className={`mb-4 -mt-12 max-smd:font-bold max-smd:-mb-4 max-lg:font-bold max-lg:text-2xl lg:text-4xl
						}`}
					>
						{title}
					</h1>
					<SessionCardContainer
						liveWebinarSessions={liveWebinarSessions}
						locale={locale}
					/>

					<br />
					<br />
					<div ref={webcastRefHR} id="webcastHR">
						<NewGluCardContainer
							cardContainerContent={{
								id: 'course-container',
							}}
							cardVariant="courseList"
							data={courseData}
							associatedCategory={associatedCategoryHR}
							associatedCategoryHS
							webinarsOnly
							locale={locale}
						/>
					</div>
					<div ref={webcastRefHS} id="webcastHS">
						<NewGluCardContainer
							cardContainerContent={{
								id: 'course-container',
							}}
							cardVariant="courseList"
							data={courseData}
							associatedCategory={associatedCategoryHS}
							associatedCategoryHR
							webinarsOnly
							locale={locale}
						/>
					</div>
				</PageSection>
			</div>
			<ScrollToTop />
		</GoogleReCaptchaProvider>
	);
};

export default NewWebinarLibrary;
